import { useAgentHandlerLink as useSharedAgentHandlerLink } from '#pplx/frontend/apps/ask/connectors/auth/useAgentHandlerLink.js';
export const useAgentHandlerLink = useSharedAgentHandlerLink;
//# sourceMappingURL=useAgentHandlerLink.js.map